module.exports = __webpack_public_path__ + "img/theme2.233f377b.png";